import * as React from 'react'
import { useContext, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import CommonContext from '../CommonContext'
import { ResourcesOverviewTagShape } from '../../api/api_data_types'
import { getResourcesOverviewTags } from '../../api/resources_overview_tags'
import { getTextColorForBackground } from '../helpers/color'
import TagPopup from './TagPopup'
import ErrorMessage from '../job_plannings/list_app/ErrorMessage'

type PopupState = {
  open: boolean
  mode: 'create' | 'edit'
  tag: ResourcesOverviewTagShape | null
}

export default function TagsSection() {
  const dictionaries = useContext(CommonContext)
  const { currentUser } = dictionaries
  const isDepartmentManager = Boolean(currentUser?.is_department_manager)

  const [popupState, setPopupState] = useState<PopupState>({
    open: false,
    mode: 'create',
    tag: null,
  })

  const { isLoading, isError, data, error } = useQuery(['resources_overview_tags'], () => getResourcesOverviewTags())

  const tags = useMemo<ResourcesOverviewTagShape[]>(() => {
    return data?.data || []
  }, [data])

  const openCreatePopup = () => {
    setPopupState({
      open: true,
      mode: 'create',
      tag: null,
    })
  }

  const openEditPopup = (tag: ResourcesOverviewTagShape) => {
    if (!isDepartmentManager) return

    setPopupState({
      open: true,
      mode: 'edit',
      tag,
    })
  }

  const closePopup = () => {
    setPopupState(prev => ({ ...prev, open: false }))
  }

  return (
    <div className="mt-3">
      <div className="mb-2 font-weight-bold">Tags</div>
      {isLoading && (
        <div className="text-center">
          <i className="fa fa-spinner fa-spin" />
        </div>
      )}
      {!isLoading && (
        <div className="d-flex flex-wrap align-items-center">
          {tags.map(tag => {
            const style = {
              backgroundColor: tag.color,
              color: getTextColorForBackground(tag.color),
              borderColor: 'rgba(0, 0, 0, 0.15)',
            }

            if (isDepartmentManager) {
              return (
                <button
                  key={tag.id}
                  type="button"
                  className="badge badge-pill border mr-2 mb-2 px-3 py-2"
                  style={style}
                  onClick={() => openEditPopup(tag)}
                >
                  {tag.name}
                </button>
              )
            }

            return (
              <span key={tag.id} className="badge badge-pill border mr-2 mb-2 px-3 py-2" style={style}>
                {tag.name}
              </span>
            )
          })}
          {!isLoading && tags.length === 0 && <span className="text-muted font-italic mr-2 mb-2">Ingen tags</span>}
          {isDepartmentManager && (
            <button type="button" className="btn btn-outline-primary btn-sm mb-2" onClick={openCreatePopup}>
              + Tilføj tag
            </button>
          )}
        </div>
      )}
      <ErrorMessage isError={isError} error={error} className="error-message mt-2" />

      <TagPopup open={popupState.open} mode={popupState.mode} tag={popupState.tag} onClose={closePopup} />
    </div>
  )
}
